import * as $ from 'jquery'

window.jQuery = window.$ = $


// WEBPACK FOOTER //
// ./src/include/jquery.js